import { get } from "lodash";
import { Form, Link, redirect, useNavigate, type ActionFunction } from "react-router";

import { Api, Types } from "@/services";
import { httpSuccessToast } from "@/utils";
import { FormRow, Logo, RegisterAndLoginPageWrapper, SubmitBtn } from "@/components";

export const loginAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const payload = Object.fromEntries(formData) as unknown as Types.Request.Login;

  const response = await Api.Login(payload);
  const accessToken = get(response, "data.access_token", "");
  localStorage.setItem("t$o@k!en*", accessToken);
  httpSuccessToast(response, "Login successful");
  return redirect("/dashboard");
};

const Login = () => {
  const navigate = useNavigate();

  const loginDemoUser = async () => {
    const payload = { email: "test@test.com", password: "secret123" };

    const resp = await Api.Login(payload);
    const accessToken = get(resp, "data.access_token", "");
    localStorage.setItem("t$o@k!en*", accessToken);
    httpSuccessToast(resp, "Take a test drive");
    navigate("/dashboard");
  };

  return (
    <RegisterAndLoginPageWrapper>
      <Form className="form" method="POST">
        <Logo />
        <h4>Login</h4>
        <FormRow type="email" name="email" />
        <FormRow type="password" name="password" />
        <SubmitBtn formBtn />
        <button className="btn btn-block" type="button" onClick={loginDemoUser}>
          explore the app
        </button>
        <p>
          Not a member yet?{" "}
          <Link className="member-btn" to="/register">
            Register
          </Link>
        </p>
      </Form>
    </RegisterAndLoginPageWrapper>
  );
};

export default Login;
